import React, { useState } from "react";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../stories/Button/Button";
import { Col, Modal, Row } from "react-bootstrap";
import classes from "./ErrorOccurModal.module.css";
import {
  CancelredIcon,
  checkCircleGreen,
  coachDemoImg,
  coachDemoImg2,
  Sad,
  starIconss,
  tableImg,
} from "../../../../constant/imagePath";
import StarRatings from "react-star-ratings";
import moment from "moment";
import {
  AiFillCalendar,
  AiFillClockCircle,
  AiOutlineLeft,
  AiOutlineRight,
} from "react-icons/ai";
import { BsChatDots } from "react-icons/bs";
import { MdPlace } from "react-icons/md";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import { ReactSVG } from "react-svg";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";

const ErrorOccurModalMobile = ({ show, setShow, data }) => {
  const [pagitnationSteps, setPagitnationSteps] = useState(1);

  const [savedRepliesState, setSavedRepliesState] = useState([]);

  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        width={"468px"}
        height={"188px"}
        padding={"32px"}
        showCloseIcon={true}
        // footer={true}
      >
        <div className={classes.modalContent}>
          <div className={classes.textAlignCenter}>
            <div className={classes.iconDiv}>
              <ReactSVG src={Sad} />
            </div>
            <h1 className={classes.marginBottom16} style={{ ...Fonts.h4f26 }}>
              An error occured
            </h1>
            <p
              className={classes.marginBottom24}
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
            >
              The system is currently experiencing technical difficulties.
            </p>
            <div className={classes.dGridJustifyContentCenter}>
              <Button
                primary={true}
                customStyle={{
                  padding: "12px 44px",
                  width: "100%",
                  marginBottom: 15,
                }}
                label={"Try again"}
              />
              <Button
                primary={false}
                customStyle={{
                  padding: "12px 44px",
                  marginRight: 20,
                  width: "100%",
                }}
                label={"Cancel"}
              />
            </div>
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default ErrorOccurModalMobile;

ErrorOccurModalMobile.defaultProps = {
  data: {
    dateItem: {
      icon: AiFillCalendar,
      date: "Mon Aug 16 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
    },
    timeItem: {
      icon: AiFillClockCircle,
      time: "12:30PM- 2:30PM",
    },
    placeItem: {
      icon: MdPlace,
      description: "DeWitt Clinton Park, W 54th St, New York, NY",
    },

    userData: {
      displayName: "Kate Johnson",
      photo: coachDemoImg2,
      rating: 5,
      sport: "Student",
      cancellation: "3",
      reviewTitle: "The coach did not show up for training.",
      reviewDescription:
        "The coach was 20 minutes late for training. When I reprimanded him, he was rude. In general, I am very dissatisfied with the student's behavior and ask him to be banned.",
    },

    coachData: {
      coachName: "Michael Baumgardner",
      coachImg: tableImg,
    },

    userDetailsCardsData: [
      {
        title: "Plans have changed.",
        description:
          "Unfortunately, I am having problems of a family nature. Because of this, I will not be able to attend the training",
        timeAgo: "Within 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
      {
        title: "Medical emergency",
        description:
          "Yesterday I broke my arm and spent the day in the hospital, so I could not cancel the class in advance.",
        timeAgo: "Within 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
      {
        title: "Other",
        description: "",
        timeAgo: "Before 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
    ],
  },
};
